import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LogOut, Server, Calendar, BarChart3, Shield } from 'lucide-react';

const Header = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // 기본 네비게이션 메뉴
  const baseNavigation = [
    { name: '대시보드', href: '/dashboard', icon: BarChart3 },
    { name: '인스턴스', href: '/instances', icon: Server },
    { name: '스케줄', href: '/schedule', icon: Calendar },
  ];

  // 관리자 메뉴 (추후 권한 체크 로직 추가 예정)
  const adminNavigation = [
    { name: '관리자', href: '/admin', icon: Shield, admin: true },
  ];

  // 관리자 권한 체크하여 네비게이션 메뉴 구성
  const navigation = user && user.isAdmin 
    ? [...baseNavigation, ...adminNavigation] 
    : baseNavigation;

  const isActive = (href) => location.pathname === href;

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* 로고 및 네비게이션 */}
          <div className="flex items-center space-x-8">
            <div className="flex-shrink-0">
              <h1 className="text-xl font-bold text-gray-900">
                AWS Resource Control
              </h1>
            </div>
            
            <nav className="hidden md:flex space-x-4">
              {navigation.map((item) => {
                const Icon = item.icon;
                return (
                  <button
                    key={item.name}
                    onClick={() => navigate(item.href)}
                    className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                      isActive(item.href)
                        ? 'bg-blue-100 text-blue-700'
                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                    }`}
                  >
                    <Icon size={18} />
                    <span>{item.name}</span>
                  </button>
                );
              })}
            </nav>
          </div>

          {/* 사용자 정보 및 로그아웃 */}
          <div className="flex items-center space-x-4">
            <div className="hidden md:block">
              <div className="text-sm text-gray-600">
                <div className="flex items-center space-x-2">
                  <span className="font-medium text-gray-900">
                    {user?.name || user?.username || user?.email || 'User'}
                  </span>
                  {user?.isAdmin && (
                    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-800">
                      관리자
                    </span>
                  )}
                </div>
                {user?.organization && (
                  <div className="text-xs text-gray-500">
                    {user.organization}
                  </div>
                )}
              </div>
            </div>
            
            <button
              onClick={onLogout}
              className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors duration-200"
              title="로그아웃"
            >
              <LogOut size={18} />
              <span className="hidden sm:inline">로그아웃</span>
            </button>
          </div>
        </div>
      </div>

      {/* 모바일 네비게이션 */}
      <div className="md:hidden border-t border-gray-200">
        <div className="px-4 py-2 space-y-1">
          {navigation.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.name}
                onClick={() => navigate(item.href)}
                className={`flex items-center space-x-3 w-full px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                  isActive(item.href)
                    ? 'bg-blue-100 text-blue-700'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                <Icon size={18} />
                <span>{item.name}</span>
              </button>
            );
          })}
        </div>
      </div>
    </header>
  );
};

export default Header;